module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3d9e2585d6ed12b9fb994438e0c4c42a.svg";